import slugify from "slugify";

/**
 * Slug as she types: `trim: false` keeps a trailing "-", otherwise "6tygodnidobikini-" would
 * snap back to "6tygodnidobikini" and the next segment could never be typed.
 */
export const slugifyWhileTyping = (value: string) => slugify(value, { lower: true, trim: false });

/** The slug that gets saved: no leading or trailing "-". */
export const slugifyForSave = (value: string) => slugify(value, { lower: true });
